export class LabelHarnessController {}
